var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-15 px-10 d-flex justify-center"},[_c('p',[_vm._v(_vm._s(_vm.$t('global.noDevicesText')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }